import { Link } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import { ArrowIcon } from '../components/ui/Icons';

export default function NotFoundPage() {
  const { t } = useLocale();
  return (
    <main id="main-content" className="not-found">
      <span>404</span>
      <h1>YourApplicant</h1>
      <p>{t.home.hero.subtitle}</p>
      <Link to="/">{t.common.actions.backHome}<ArrowIcon /></Link>
    </main>
  );
}
